import React from "react";
import {Layout, Title, Description} from "./styles";


interface ExplainProps {
    title: React.ReactNode;
    description: React.ReactNode;
}
function Explain(props: ExplainProps) {
    const {
        title,
        description,
    } = props;
    return <Layout>
        <Title>
            {title}
        </Title>
        <Description>
            {description}
        </Description>
    </Layout>
}

export default Explain;